import { render, staticRenderFns } from "./ReviewRemoveConfirm.vue?vue&type=template&id=514b745a&"
import script from "./ReviewRemoveConfirm.vue?vue&type=script&lang=ts&"
export * from "./ReviewRemoveConfirm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports